import api from "./api";
import qs from "qs";

export type FeedbackItemCreateProps = {
    id?: number;
    name: string;
    status: "ativo" | "inativo";
    respondent: "fotop" | "proprietario" | "cliente";
};

const FeedbackItem = {
    async list({ filters = {} }) {
        const query = qs.stringify({ filters });
        return api.get(`/v1/job/feedback-item?${query}`).then((res) => res.data);
    },
};

export default FeedbackItem;
